var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0A807FD7-6E88-4525-852A-9D00E4D36754") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "U\\u017Esakymas-priimtas",
    transform: "translate(-485.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(485.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.863961, 10.585786) rotate(-315.000000) translate(-11.863961, -10.585786) translate(8.363961, 5.085786)",
    fill: "#00B39E"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    style: {
      mixBlendMode: "multiply"
    },
    x: 0.757359313,
    y: 8.24264069,
    width: 6,
    height: 2,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(5.757359, 5.242641) rotate(-180.000000) translate(-5.757359, -5.242641) ",
    x: 4.75735931,
    y: 0.242640687,
    width: 2,
    height: 10,
    rx: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z",
    id: "Oval",
    fill: "#00B392",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success-circle.8f1087adc3c6a5ac5094d378063f9e49.svg";
export { ForwardRef as ReactComponent };